import { render, staticRenderFns } from "./Wrap.vue?vue&type=template&id=8225b9a4&scoped=true&"
import script from "./Wrap.vue?vue&type=script&lang=js&"
export * from "./Wrap.vue?vue&type=script&lang=js&"
import style0 from "./Wrap.vue?vue&type=style&index=0&id=8225b9a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8225b9a4",
  null
  
)

export default component.exports